import { createIsomorphicFn } from "@tanstack/react-start";

function makeCC(sMaxAge: number, swr: number) {
  return `public, max-age=60, s-maxage=${sMaxAge}, stale-while-revalidate=${swr}`;
}

/** 7 d — SEO listing pages, hub pages, blog, static content.
 * ponytail: long edge TTL — listings are stable; more re-crawl hits served
 * from CloudFront edge instead of origin+Aurora, cutting ACU pressure. */
export const setSeoPageCache = createIsomorphicFn()
  .server(async () => {
    const { setResponseHeaders } = await import("@tanstack/react-start/server");
    setResponseHeaders({ "Cache-Control": makeCC(604800, 2592000) });
  })
  .client(async () => {});

/** 1 h — provider detail pages, homepage */
export const setMediumCache = createIsomorphicFn()
  .server(async () => {
    const { setResponseHeaders } = await import("@tanstack/react-start/server");
    setResponseHeaders({ "Cache-Control": makeCC(3600, 86400) });
  })
  .client(async () => {});

/** 10 min — search results (dynamic, changes as providers are added) */
export const setSearchCache = createIsomorphicFn()
  .server(async () => {
    const { setResponseHeaders } = await import("@tanstack/react-start/server");
    setResponseHeaders({ "Cache-Control": makeCC(600, 3600) });
  })
  .client(async () => {});
